import { Component, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ModalService } from '@services/modal/modal.service';

@Component({
    selector: 'app-congelamiento-saldos-terminos-y-condiciones-modal',
    templateUrl: './congelamiento-saldos-terminos-y-condiciones-modal.component.html',
    styleUrls: ['./congelamiento-saldos-terminos-y-condiciones-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class CongelamientoSaldosTerminosYCondicionesModalComponent {

  public titulo: string = "Términos y condiciones";	
  public selectTab: string = "términos y condiciones";


  constructor(private readonly modalCtr: ModalController, private readonly modalService:ModalService) { }


  iconoCerrar() {
    this.modalCtr.dismiss(false);
  }

  botonAceptar() {
    this.modalService.clickAceptModal.next(true);
    this.modalCtr.dismiss(true);
  }
  
}

